import {Component, OnInit, Inject, Output, EventEmitter, ChangeDetectorRef, ViewRef,HostListener} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { Subscription, Observable, of } from 'rxjs';
import { StateService } from '../../../services/state.service';
import { UtilitaryService } from '../../../services/utilitary.service';
import { Router } from '@angular/router';
import { formatDate, DatePipe } from '@angular/common';

import { AtylService } from '../../service/atyl.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PrintDialog } from '../../../views/partials/layout/dialog/print-dialog.component';
import {  MatProgressSpinnerModule  } from '@angular/material';
import { ConfirmComponent } from '../../../views/partials/layout/dialog/confirm.component'
import { DialogService } from '../../../services/dialog-service.service';

import * as moment from 'moment'
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { LOCALE_ID } from '@angular/core';
import { BaseDialogComponent } from '../../../base/dialog-base/dialog-base.component'

@Component({
    selector: 'form-dialog-formulaire-with-sf',
    styleUrls: ['./form-dialog-formulaire-with-sf.component.css'],
    templateUrl: 'form-dialog-formulaire-with-sf.component.html',
	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
export class FormDialogFormulaireWithSFComponent extends BaseDialogComponent implements OnInit {
    dataForm: any;
    demandeForm: any;
    dateForm: any;
    loading: boolean = true;
 	loadingPrint:boolean= false;

    listUnderForms: any[] = [];
    atylComponents: any;
    atylDocuments: string;
    atylTemplate: string;
    atylDemand: any;
    actionForm: string;
	atylDossier: any;
	currentSection: any;

    currentForm: any;
    nextState: string = "";
    statusForm: string = "1";
    avisForm: string = "0";
    noexit: boolean = false;
    indexForm: any = 0;
    hasPrevButton: boolean = false;
    hasNextButton: boolean = false;
    isEditable: boolean = true;
	isHistoric: boolean = false;
	 
    @Output() submited = new EventEmitter<any>();
    
	formLoaded:boolean=false;
	sectionEvent:EventEmitter<any> = new EventEmitter<any>();
	showErrorEvent:EventEmitter<any> = new EventEmitter<any>();
	formData:any;
	formChanged:boolean=false;
	formValid:boolean=false;
		
	user:any;
	
    constructor(
        public dialogRef: MatDialogRef<FormDialogFormulaireWithSFComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private atylService: AtylService,
        public changeDetectorRef: ChangeDetectorRef,
        private router: Router,
        private utilities: UtilitaryService,
        private datePipe: DatePipe,
        private snackbar: MatSnackBar,
        private dialog: MatDialog,
        public dialogService: DialogService,
	 private stateService: StateService
        //IMPORTANT : le moteur atyl est un composant dynamique, pour que l'appli render les changements,
        //            il faut lui spécifier qu'il faut une attention particulière au component
        //            ChangeDetectorRef nous permet de faire les check manuellement pour garantir la construction des composants dynamiques
    ) {
					super(dialogRef, dialogService, changeDetectorRef)

	}

    ngOnInit() {
		this.dialogRef.disableClose = true;
		this.stateService.user.subscribe((user) => {
		      this.user = user;
	    });
		
        this.atylComponents = "";
        this.atylTemplate = "";
        this.atylDocuments = "";
        this.atylDemand = "";
        if(this.data && this.data.noexit){
          this.noexit = true;
        }
        if ((this.atylDossier == undefined || !this.atylDossier) && this.data.dossier != undefined && this.data.dossier) {
			this.atylDossier = this.data.dossier 
        }
        
        this.dataForm=this.data;
         console.log("data dem form",this.dataForm);
        if(this.data && this.data.isEditable !== undefined)
          this.isEditable = this.data.isEditable;
		if(this.data && this.data.isHistoric !== undefined)
		        this.isHistoric = this.data.isHistoric;
		
        if(!this.data.create){
	     // this.formValid=false;
          this.atylService.getFormulaireByID(this.data.id, this.data.formType).subscribe((res) => {
              console.log(res);
              if (res.result!=undefined) {
              this.demandeForm = res.result;
              this.dateForm = this.datePipe.transform(this.demandeForm.creationdate) ;
              if(res.result && res.result.childs){
                  res.result.childs.forEach((child) => {
                      res.result.form.under_form.forEach((form, index) => {
                          if(child.form.key === form.key)
                          {
                            res.result.form.under_form[index].demande = child;
                            res.result.form.under_form[index].child = true;
                            res.result.form.under_form[index].status = child.status;
                          }
                      });
                  });
              }
              this.listUnderForms = res.result.form.under_form;
              if(res.result && res.result.form && res.result.form.fields.length > 0 && res.result.form.template){
                  res.result.form.parent = true;
                  res.result.form.status = res.result.status;
                  this.listUnderForms.unshift(res.result.form);
              }
              if(res.result && res.result.form && res.result.form.fields /*&& res.result.documents*/){
                  
				if (res.result.demande!=undefined)
					res.result.form.demande=res.result.demande;
				if (res.result.instruction!=undefined)
					res.result.form.instruction=res.result.instruction;

				
                  this.currentForm = res.result.form;
                  this.atylComponents = JSON.stringify(res.result.form.fields);
                  this.atylTemplate = res.result.form.template;
                  this.atylDocuments = JSON.stringify(res.result.documents);
                  this.atylDemand = res.result;
                  this.actionForm = "formulaire:set";
              }
              if(this.listUnderForms && this.listUnderForms.length > 0){
                this.hasPrevButton = true;
                this.hasNextButton = true;
                if(this.indexForm === 0)
                  this.hasPrevButton = false;
                if(this.listUnderForms.length === this.indexForm)
                  this.hasNextButton = false;
                this.changeForm(this.listUnderForms[this.indexForm], this.indexForm);
              }
              else
                this.loading = false;
               } else {
				   this.loading = false;
				    if (res.error) {
					  let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 30000
				              });
				     
				      
									  
					}	
				   
			   } 
              this.changeDetectorRef.detectChanges();
          });
        }
        else{
	      console.log("test bew form",this.data);
          this.atylService.getFormulaire(this.data.typeFormulaire, '', (this.data.instruction && this.data.instruction.ID ? this.data.instruction.ID : ''))
          .subscribe(res => {
            if (res.result!=undefined) {
	            this.demandeForm = res.result;
	              if(res.result && res.result.childs){
	                  res.result.childs.forEach((child) => {
	                      res.result.form.under_form.forEach((form, index) => {
	                          if(child.form.key === form.key)
	                          {
	                            res.result.form.under_form[index].demande = child;
	                            res.result.form.under_form[index].child = true;
	                            res.result.form.under_form[index].status = child.status;
	                          }
	                      });
	                  });
	              }
	              console.log('listUnderForms:',res.result);
	              this.listUnderForms = res.result.form.under_form;
	              if(res.result && res.result.form && res.result.form.fields.length > 0 && res.result && res.result.form.template){
	                  res.result.form.parent = true;
	                  res.result.form.status = res.result.status;
	                  this.listUnderForms.unshift(res.result.form);
	              }
	              if(res.result && res.result.form && res.result.form.fields /*&& res.result.documents*/){
	                  
					if (res.result.demande!=undefined)
						res.result.form.demande=res.result.demande;
					if (res.result.instruction!=undefined)
						res.result.form.instruction=res.result.instruction;

	                  this.currentForm = res.result.form;
	                  this.atylComponents = JSON.stringify(res.result.form.fields);
	                  this.atylTemplate = res.result.form.template;
	                  this.atylDocuments = JSON.stringify(res.result.documents);
	                  this.atylDemand = res.result;
	                  this.actionForm = "formulaire:set";
	              }
	
	              
	              if(this.listUnderForms && this.listUnderForms.length > 0){
	                this.hasPrevButton = true;
	                this.hasNextButton = true;
	                if(this.indexForm === 0)
	                  this.hasPrevButton = false;
	                if(this.listUnderForms.length === this.indexForm)
	                  this.hasNextButton = false;
	                this.changeForm(this.listUnderForms[this.indexForm], this.indexForm);
	              }
	             
              
              } else {
				  if (res.error) {
					  let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 30000
				              });
				     
				       this.dialogRef.close();
									  
					}			  
				  
				  
			  }
			  this.loading = false;
	          this.changeDetectorRef.detectChanges();
			  
          });
        }
		
		/*
		this.dialogRef.backdropClick().subscribe((evt:any)=> {
				console.log("FormDialogFormulaireWithSFComponent backdropClick",evt,this.formChanged);
						
						if (this.formChanged && this.isEditable) {
							this.dialogService.open(ConfirmComponent, {
												data: {
													// libelle: 'Souhaitez-vous valider votre saisie ?'
								          libelle: "Vous avais modifié des données êtes-vous sur de vouloir quitter ?"
												},
												
											}, (res: any) => {
												
											if (res === 'true') {
									                    this.dialogRef.close();
									     }
													
												
							});
							
						}else
							this.dialogRef.close();
		  })
		  */
		
    }

    ngAfterViewInit() {
        this.sectionEvent.subscribe((section:any)=>{
            if (section!=undefined 
              && section.id!=undefined) {
                
                let btnOpen=document.getElementById("btn_section_open");
                let btnOpenelement:HTMLElement = btnOpen as HTMLElement;
                console.log("btnOpenelement:",btnOpenelement)
                btnOpenelement.addEventListener("click",this.onClick.bind(this,section),true);
                
                btnOpenelement.click();
                
                btnOpenelement.removeEventListener("click",()=>{},true); 
                
            }
        })
    }

    changeForm(form: any, index?: any,section?: any) {
        this.indexForm = index;
        this.atylComponents = '';
        this.atylTemplate = '';

		this.currentSection=section;

        if(this.listUnderForms.length > 0){
          this.hasPrevButton = true;
          this.hasNextButton = true;
          if(this.indexForm === 0)
            this.hasPrevButton = false;
          if(this.listUnderForms.length === this.indexForm+1)
            this.hasNextButton = false;
        }
        if(form.parent && this.demandeForm.ID){
            this.atylService.getFormulaireByID(this.demandeForm.ID, form.key).subscribe((res) => {
                this.demandeForm = res.result;
                this.loading = false;
                this.atylComponents = JSON.stringify(res.result.form.fields);
                this.atylTemplate = res.result.form.template;
                this.atylDocuments = JSON.stringify(res.result.documents);
                this.atylDemand = res.result;
                this.currentForm = res.result.form;
                this.actionForm = "formulaire:set";
                this.loading = false;
                if(res.result.status != undefined)
                  this.statusForm = String(res.result.status);
                if(res.result.favorable != undefined)
                  this.avisForm = String(res.result.favorable);
                this.changeDetectorRef.detectChanges();
            });
        }
        else{
            if(form.child){
              this.atylService.getFormulaireByID(form.demande.ID, form.key).subscribe((res) => {
                  this.demandeForm = res.result;
                  //this.loading = false;
                  this.atylComponents = JSON.stringify(res.result.form.fields);
                  this.atylTemplate = res.result.form.template;
                  this.atylDocuments = JSON.stringify(res.result.documents);
                  this.atylDemand = res.result;
                  this.currentForm = res.result.form;
                  this.actionForm = "formulaire:set";
                  this.loading = false;
                  if(res.result.status != undefined)
                    this.statusForm = String(res.result.status);
                  if(res.result.favorable != undefined)
                    this.avisForm = String(res.result.favorable);
                  this.changeDetectorRef.detectChanges();
              });
            }
            else
            {
             console.log("test getFormulaire",form,this.data,form.parent);
               this.atylService.getFormulaire(form.key, this.data ? this.data.id : '', (this.data.instruction && this.data.instruction.ID ? this.data.instruction.ID : '')).subscribe((res) => {
                  this.demandeForm = res.result;
                  this.loading = false;
                  this.atylComponents = JSON.stringify(res.result.form.fields);
                  this.atylTemplate = res.result.form.template;
                  this.atylDocuments = JSON.stringify(res.result.documents);
                  this.atylDemand = res.result;
                  this.currentForm = res.result.form;
                  this.actionForm = "formulaire:set";
                  this.loading = false;
                  if(res.result.status != undefined)
                    this.statusForm = String(res.result.status);
                  if(res.result.favorable != undefined)
                    this.avisForm = String(res.result.favorable);
                  this.changeDetectorRef.detectChanges();
              });
            }
        }

    }

    onClick(event:any,section:any) {
        /*let btnOpen=document.getElementById("btn_section_open");
        let btnOpenelement:HTMLElement = btnOpen as HTMLElement;
        btnOpenelement.removeEventListener("click",()=>{},true);  
        */
          setTimeout(() => {
                if (this.currentSection) {
                    let anchor=this.currentSection.id;       
                        let btnId='btn_section_'+ anchor
                        let btn=document.getElementById(btnId);
                        let btnelement:HTMLElement = btn as HTMLElement;
                        if (btnelement) {
                            console.log("curentSection btn event",btnelement);
                            btnelement.click();
                        if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                            this.changeDetectorRef.detectChanges()
                }
                    }  
                    this.currentSection=null;  
                }
                
          })
     }

    onChanged(changed: any) {
		this.formChanged=false;
		this.formValid=false;
		console.log("onChanged",changed);
		
		if (this.formData!=changed.data) {
			   this.formChanged=true;
			this.formData=changed.data;
			this.formValid=changed.valid;
			//this.formValid=true;
		}	
		if (changed) {
			
		}
		this.changeDetectorRef.detectChanges();
	}

    goChangeForm(form: any, index?: any,section?: any) {
        console.log("goChangeForm formchanged",this.formValid,this.formChanged,this.formData,this.loading);
		let toConfirm:boolean=true;
		console.log("FormAtylComponent right",this.user.droits)
		     Object.keys(this.user.droits).forEach((droit) => {
		       if(droit === "AUCUNE_CONFIRMATION" || droit === "AUCUNE_CONFIRMATION_FORMULAIRE"){
		         toConfirm = false;
		       }
		})
		console.log("FormAtylComponent right confrim",toConfirm)
		if (this.formChanged  && this.isEditable) {
			
			if (!toConfirm) {
				if (this.formValid) {
					this.onSubmit(this.formData);
					this.formData=null;
					this.formChanged=false;
					this.changeForm(form,index,section);
				}
				else
					 this.showErrorEvent.emit(true);
			}
			else
				this.dialogService.open(ConfirmComponent, {
					data: {
						// libelle: 'Souhaitez-vous valider votre saisie ?'
	          libelle: "Confirmez-vous ces informations ?"
					},
					
				}, (res: any) => {
					if (this.formValid) {
						if (res === 'true') {
		                    this.onSubmit(this.formData);
		                }
						this.formData=null;
						this.formChanged=false;
						this.changeForm(form,index,section);
					}
					else
						this.showErrorEvent.emit(true);
				});
		
		} else {
			if (!this.isEditable || this.formValid ) {
				this.formData=null;
				this.formChanged=false;
				this.changeForm(form,index,section);
			}	else {
				
				if (!this.formValid ) {
					this.showErrorEvent.emit(true);
				}
			}
		}
	}

    

    goForm(action:string) {
		console.log("goForm formchanged",this.formValid,this.formChanged,this.formData, /*this.formLoaded*/this.loading);
		
		let inc:number=(action=="next") ? 1 : -1;
		var index:number=this.indexForm+inc;
		
		let toConfirm:boolean=true;
		console.log("FormAtylComponent right",this.user.droits)
		     Object.keys(this.user.droits).forEach((droit) => {
		       if(droit === "AUCUNE_CONFIRMATION" || droit === "AUCUNE_CONFIRMATION_FORMULAIRE"){
		         toConfirm = false;
		       }
		})
		console.log("FormAtylComponent right confrim",toConfirm)
		if (this.formChanged  && this.isEditable) {
			if (!toConfirm) {
				if (this.formValid) {
					this.onSubmit(this.formData);
					if (this.listUnderForms.length>1
									&& index>=0 
									&& index< this.listUnderForms.length)
					 {
						this.formData=null;
					    this.formChanged=false;
						this.changeForm(this.listUnderForms[index],index);
					}
				}	else
					this.showErrorEvent.emit(true);
			}
				else
			  this.dialogService.open(ConfirmComponent, {
				data: {
					// libelle: 'Souhaitez-vous valider votre saisie ?</b>'
          libelle: "Confirmez-vous ces informations ?</b>"
				},
				
			}, (res: any) => {
				if (this.formValid) {
					if (res === 'true') {
						this.onSubmit(this.formData);
					} 
					
					if (this.listUnderForms.length>1
					&& index>=0 
					&& index< this.listUnderForms.length)
					 {
						this.formData=null;
					    this.formChanged=false;
						this.changeForm(this.listUnderForms[index],index);
					}
				}	else
										this.showErrorEvent.emit(true);
				
			})
		} else {
			if (!this.isEditable || this.formValid ) {
				this.formData=null;
				this.formChanged=false;
			
			
				if (this.listUnderForms.length>1
						&& index>=0 
						&& index< this.listUnderForms.length)
					 {
						
						this.changeForm(this.listUnderForms[index],index);
					}
					}	else {
									
					if (!this.formValid ) {
						this.showErrorEvent.emit(true);
					}
				}
				
		}
		
		
	}

    onLoaded(loaded: boolean){
		this.formLoaded=loaded;
        if(loaded){
            this.changeDetectorRef.markForCheck();
			this.sectionEvent.next(this.currentSection);
        }   
    }

    getScrollTop() {
        return this.currentSection;
    }

    getSubmittedEmitter() {
        return this.submited;
      }

    onSubmit(values: any) {
		 this.loadingPrint=true;
		 this.loading = true;
        if(!values["close"]){
          this.data.closeWhenValidate = false;
          if(values["next"])
            this.indexForm++;
          if(values["prev"])
            this.indexForm--;
        }
        else if(values['close'])
          this.data.closeWhenValidate = true;
        if(this.currentForm)
          this.atylDemand.form = this.currentForm;
        for(var i=0;i<this.atylDemand.form.fields.length;i++) {
          var field=this.atylDemand.form.fields[i];
          if (values.hasOwnProperty(field.ID)) {
            var val=values[field.ID];
    
    		if ( val == '' || val == undefined) {
				val = null
			}
    
    
            if (val && field.field.type=='date'
            && val!=undefined
             && val != "" ) {
              var utcDate=formatDate(val,"yyyy-MM-ddTHH:mm:ss","fr-FR");
              if (val instanceof moment) {
						var momentObj = moment(val);
						utcDate=momentObj.utcOffset(0, false).format("YYYY-MM-DDTHH:mm:ss")+"Z"
					}
					
					
				console.log("FormDialogFormulaireWithSFComponent date submit",field,utcDate,val);
              val=utcDate;
              
             
              
            }
			
			if (	 field.field.type == 'selectionlist'  															) 
								{
									console.log("submit selection list bedore",val)	
									if (val==undefined || val=="" || val==null)
										val=[];
									
			}
			
            
            field["value"]=val;
            this.atylDemand.form.fields[i]=field;
          }
        }
        
        console.log("FormDialogFormulaireWithSFComponent onSubmit",values,this.atylDemand.form.fields);
       
        
        
        if(this.currentForm){
          this.atylDemand.form = {
            form: this.currentForm.ID,
            key: this.currentForm.key
          }
        }
        if(this.nextState)
          this.atylDemand.transition = this.nextState;
          console.log("test form open 0",this.data);
          if(!this.atylDemand.ID){
	        console.log("test form open",this.data);
            this.atylService.setNewFormulaire(this.currentForm.key,this.currentForm.fields, (this.data.instruction && this.data.instruction.ID ? this.data.instruction.ID : ''), this.currentForm.parent ? '' : this.data.id, values.etat, values.favorable)
            .subscribe(submitted => {
				if (submitted.error!=undefined) {
					  let message:string=(submitted.error.data!=undefined) ? submitted.error.data : submitted.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 30000
				              });
				     
				       this.dialogRef.close();
									  
			} else {
				this.loadingPrint=false;
		 	  
              this.submited.emit(submitted);
              let snackBarRef = this.snackbar.open('Formulaire enregistré','', {
                duration: 10000
              });
              if(this.data && this.data.closeWhenValidate)
                this.dialogRef.close(submitted);
              else{
					if (submitted.result ) {
						this.data.create=false;
						this.data.v3=false;
						if( submitted.result.parent!=undefined
						&& submitted.result.parent.ID!=undefined) {
							
							this.data.id=submitted.result.parent.ID;
							
						} else {
							
							if (
								submitted.result.form!=undefined
								&& submitted.result.form.is_form!=undefined
								&& !submitted.result.form.is_form
								&& submitted.result.ID!=undefined)
									this.data.id=submitted.result.ID;
							
						}
						
						console.log("onSubmit on submit without close", this.data);
						this.ngOnInit()
					}
				}
				}
            });
          }
          else{
			console.log("save FormDialogFormulaireWithSFComponent",this.currentForm,this.data,this.demandeForm);
			
            this.atylService.setFormulaire(this.currentForm, this.data.instruction, this.demandeForm.ID, values.etat, this.currentForm.parent ? '' : this.data.id, values.favorable ? values.favorable : '0',this.isHistoric).subscribe( (res) => {
    		 if (res.error!=undefined) {
					  let message:string=(res.error.data!=undefined) ? res.error.data : res.error.message;
					  let snackBarRef = this.snackbar.open(message,'', {
				                duration: 30000
				              });
				     
				 this.dialogRef.close();
									  
			} else {
    		this.loadingPrint=false;
		 	
              this.submited.emit(res.result);
              let snackBarRef = this.snackbar.open('Formulaire enregistré','', {
                duration: 10000
              });
              if(this.data && this.data.closeWhenValidate)
                this.dialogRef.close(res.result);
              else
                this.ngOnInit();
              }  
            })
          }
        
      }

      printForm(id:any){
        this.loading = true;
       
        this.atylService.printFormulaire(id, true,false).subscribe((res) => {
          this.loading=false;
          if(res.result && res.result.length > 0)
            window.open(res.result[0].value.url);
          else
            of(window.confirm("Pas de donnée disponible"));
        });
      }
	  
	  closeForm() {
				if (this.formChanged) {
									this.dialogService.open(ConfirmComponent, {
														data: {
															// libelle: 'Souhaitez-vous valider votre saisie ?'
										          libelle: "Vous avais modifié des données êtes-vous sur de vouloir quitter ?"
														},
														
													}, (res: any) => {
														
													if (res === 'true') {
											                    this.dialogRef.close();
											     }
															
														
									});
									
			}else
									this.dialogRef.close();
	  }
}